import React, { Component } from "react";
import { Table } from "react-bootstrap";
import Aux from "../../../../hoc/Auxilliary";
import * as CONSTANTS from "../../../../constants";
// import { getBrightcoveAccountId } from "../../../../localstorage-service";
import TimeAgo from "react-timeago";
import { formatUtcDate } from "../../../../utilities";

class Grid extends Component {
  edit(value) {
    this.props.edit(value);
  }
  delete(value) {
    this.props.delete(value);
  }
  render() {
    return (
      <Table striped bordered condensed hover>
        <thead>
          <tr>
            {this.props.headers.map((header, index) => {
              return <th key={index}>{header}</th>;
            })}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {this.props.values.map((value, index) => {
            return (
              <tr key={value[this.props.indexName]}>
                {this.props.properties.map((property, idxProperty) => {
                  const isAdminUser =
                    String(value["Email"]).toLowerCase() === "admin@asml.com" ||
                    String(value["Email"]).toLowerCase() === "superadmin@asml.com";

                  const isPublished = value["IsPublished"];
                  if (idxProperty === 0) {
                    return <td key={idxProperty}>{index + 1}</td>;
                  } else if (idxProperty === this.props.properties.length - 1) {
                    return (
                      <td key={idxProperty}>
                        {!isAdminUser ? (
                          <Aux>
                            <a onClick={() => this.props.edit(value)}>Edit</a>
                            {!this.props.hideDelete && (
                              <Aux>
                                {" | "}
                                <a onClick={() => this.props.delete(value)}>Delete</a>
                              </Aux>
                            )}
                            {this.props.extraActions &&
                              this.props.extraActions.map((extraAction, idxExtraAction) => {
                                const extraName = this.props.extraActionNames[idxExtraAction];
                                if (!isPublished && (extraName === "Unpublish" || extraName === "Copy Code")) {
                                  return null;
                                }

                                return (
                                  <Aux key={idxExtraAction}>
                                    {" | "}
                                    <a onClick={() => extraAction(value)}>
                                      {isPublished && extraName === "Publish"
                                        ? "Republish"
                                        : this.props.extraActionNames[idxExtraAction]}
                                    </a>
                                  </Aux>
                                );
                              })}
                          </Aux>
                        ) : null}
                      </td>
                    );
                  } else {
                    if (
                      String(property).toLowerCase().indexOf("name") >= 0 &&
                      this.props.linkProperty === "Name" &&
                      String(value["VideoTypeId"]) === "1"
                    ) {
                      return (
                        <td key={String(value[property])}>
                          {/* <iframe
                            title="ms stream video"
                            width="320"
                            height="180"
                            src={`https://web.microsoftstream.com/embed/video/${String(
                              value["BrightcoveVideoId"]
                            )}?autoplay=false&amp;showinfo=false`}
                            allowFullScreen={true}
                            style={{ border: "none" }}
                          ></iframe> */}
                          <a
                            target="_blank"
                            href={
                              String(value["FilePath"]) !== "null"
                                ? String(value["FilePath"])
                                : `https://web.microsoftstream.com/embed/video/${String(
                                    value["BrightcoveVideoId"]
                                  )}?autoplay=false&amp;showinfo=true`
                            }
                          >
                            {String(value[property])}
                          </a>
                        </td>
                      );
                    } else if (
                      String(property).toLowerCase().indexOf("name") >= 0 &&
                      String(value["VideoTypeId"]) === "2"
                    ) {
                      return (
                        <td key={String(value[property])}>
                          <a
                            target="_blank"
                            href={
                              String(value["FilePath"]) !== "null"
                                ? String(value["FilePath"])
                                : `https://web.microsoftstream.com/embed/video/${String(
                                    value["BrightcoveVideoId"]
                                  )}?autoplay=false&amp;showinfo=true`
                            }
                          >
                            {String(value[property])}
                          </a>
                        </td>
                      );
                    } else if (String(property).toLowerCase().indexOf("image") >= 0) {
                      return (
                        <td key={String(value[property])}>
                          <img width="300px" src={CONSTANTS.API_BASE_URL + String(value[property])} alt={idxProperty} />
                        </td>
                      );
                    } else if (
                      String(property).toLowerCase() === "created" ||
                      String(property).toLowerCase() === "publishedon"
                    ) {
                      return (
                        <td key={String(value[property])}>
                          <TimeAgo date={formatUtcDate(String(value[property]))} live={false} />
                        </td>
                      );
                    } else {
                      return <td key={idxProperty}>{String(value[property])}</td>;
                    }
                  }
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default Grid;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Common/Grid.js